<template>
  <a-card :bordered="false">
    <a-button type="primary" icon="plus" @click="showModal">新建</a-button>
    <custom-page-table
      :queryParams="queryParams"
      style="margin-top:16px;"
      ref="table"
      :columns="getcolumns()"
      :requestPromise="loadPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="onReauthorization(rowItem.record)">重新授权</a>
        <!--        <a-divider type="vertical"></a-divider>-->
        <!--        <a>关联下单账户</a>-->
      </span>
    </custom-page-table>
    <selected-product-dialog
      :show="selectVisible"
      title="关联下单账号"
      ref="pageList"
      :itemNames="['search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadAccountPromise"
      row-key="proId"
      @close="selectVisible = false"
      :columns="getGoodsColumns()"
    >
      <div style="margin-bottom: 10px;" slot="tips">
        温馨提示：下单账户仅能从分销员中选取并绑定，每个飞猪店铺仅能绑定一个账号
      </div>
      <a-form-item label="搜索名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="搜索手机号、真实姓名"></a-input>
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a>选择</a>
      </template>
    </selected-product-dialog>
    <a-modal title="新建授权码绑定" :width="600" :visible="visible" @cancel="visible = false" :footer="null">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="授权码" prop="authCode">
          <a-input v-model.trim="ruleForm.authCode" :maxLength="16" placeholder="请输入"></a-input>
        </a-form-model-item>
      </a-form-model>
      <a-form-model-item :wrapper-col="{ span: 16, offset:4 }">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
      </a-form-model-item>
    </a-modal>
  </a-card>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import fliggyMixins from './fliggyMixins'

export default {
  name: 'AuthorizationCodeBinding',
  components: {
    SelectedProductDialog
  },
  mixins: [fliggyMixins],
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      selectVisible: false,
      visible: false,
      selectedQueryParams: {},
      loadAccountPromise: params => this.getAccountListPromise(params),
      loadPromise: params => this.getListPromise(params),
      ruleForm: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        id: null,
        authCode: ''
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      rules: {
        authCode: [{ required: true, message: '请输入授权码', trigger: 'blur' }]
      }
    }
  },
  mounted() {

  },
  methods: {
    showModal() {
      this.visible = true
      this.ruleForm = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: null,
        authCode: ''
      }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submintData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submintData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getServerApiService().post('feizhu/link/authCodeBind', params)
        .then(res => {
          this.$message.success('授权码绑定成功')
          this.$refs.table.refresh(true)
          this.visible = false
        })
        .catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('feizhu/link/queryMerchantAuthList', params)
    },
    //弹窗
    getAccountListPromise(params) {
      return this.getHttpServices().getServerApiService().post('feizhu/link/queryAccount', params)
    },
    onReauthorization(record) {
      this.getLogUtils().logWithTag('onReauthorization', record)
      this.visible = true
      this.ruleForm = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: record.id,
        authCode: record.authCode
      }
    },
    getGoodsColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '60%'
        },
        {
          title: '当前分类',
          dataIndex: 'proType'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getcolumns() {
      return [
        {
          title: '授权码',
          dataIndex: 'authCode'
        },
        {
          title: '飞猪店铺名称',
          dataIndex: 'taoBaoUserNick'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '授权到期时间',
          dataIndex: 'expiresTime'
        },
        {
          title: '状态',
          dataIndex: 'stateStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>